import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from 'src/lib/auth/auth.service';
import { BrandApi } from 'src/lib/repository/brand/brand.api';
import { IBrand } from 'src/lib/repository/brand/brand.model';

export const brandDetailAccountResolver: ResolveFn<IBrand> = () => {
  const authService = inject(AuthService);
  const brandApi = inject(BrandApi);

  return brandApi.findItem(authService.account.brandId);
};
